import "react-datepicker/dist/react-datepicker.css";
import './dateRangePicker.css';
import {useState} from "react";
import DatePicker from "react-datepicker";
import { getMonth, getYear, add } from 'date-fns';

const DateRangePicker = (
    {
        classes = '',
        selectRange = false,
        startDate = new Date(),
        endDate = selectRange ? add(startDate, {days: 2}) : null,
        onDateChange = (val) => {}
    }
) => {
    const [startingDate, setStartingDate] = useState(startDate);
    const [endingDate, setEndingDate] = useState(endDate);
    const months = [
        'Jan','Feb', 'Mar','Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const onChange = (date) => {
        onDateChange(date);
        if (!selectRange) {
            setStartingDate(date);
        } else {
            const [start, end] = date;
            setStartingDate(start);
            setEndingDate(end);
        }
    };
    return (
        <div className={`react-date-picker input-box ${classes}`}>
            <DatePicker
                renderCustomHeader={(
                    {
                        date,
                        changeYear,
                        changeMonth,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled,
                    }
                ) => (
                    <div className={'date-picker-header flex hr-space-between margin-b-5'}>

                        <div className="month-year flex gap-0">
                            <div className="margin-r-5">{months[getMonth(date)]}</div>
                            <div className="">{getYear(date)}</div>
                        </div>
                        <div className="flex gap-0">
                            <div className={'arrow-button prev'}
                                 onClick={decreaseMonth}>
                            </div>
                            <div className={'arrow-button next margin-l-5'}
                                 onClick={increaseMonth}>
                            </div>
                        </div>

                    </div>
                )}
                selectsRange={selectRange}
                selected={startingDate}
                onChange={onChange}
                startDate={startingDate}
                endDate={endingDate}
                showPopperArrow={false}
            />
        </div>
    );
};

export default DateRangePicker;
